import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { App } from '@capacitor/app';
import { getNativePlatform, isNativePlatform } from '@/utils/capacitor';
import { useOverlayStack } from '@/contexts/OverlayStackContext';
import { shouldExitOnHardwareBack } from '@/utils/nativeNavigation';

export function useAndroidBackButton(): void {
  const navigate = useNavigate();
  const location = useLocation();
  const { closeTop } = useOverlayStack();

  useEffect(() => {
    if (!isNativePlatform() || getNativePlatform() !== 'android') {
      return;
    }

    let removed = false;
    const handlePromise = App.addListener('backButton', () => {
      if (closeTop()) {
        return;
      }
      if (!shouldExitOnHardwareBack(location.pathname)) {
        navigate(-1);
        return;
      }
      void App.exitApp();
    });

    return () => {
      removed = true;
      void handlePromise.then((handle) => {
        if (!removed) {
          return;
        }
        void handle.remove();
      });
    };
  }, [closeTop, location.pathname, navigate]);
}
